export function getBanners(jsonString) {
  try {
    const data =
      typeof jsonString === "string"
        ? JSON.parse(jsonString)
        : jsonString;

    const banners =
      data?.properties
        ?.MGAM_conteudo
        ?.items?.[0]
        ?.content
        ?.properties
        ?.MGAM_banners;

    return Array.isArray(banners) ? banners : [];
  } catch (error) {
    console.error("Erro ao fazer parse do JSON:", error.message);
    return [];
  }
}

export function getBannerPath(banner){
  try{
    const imagePath = banner?.route?.path;
    return imagePath;
  }catch(error){
    console.error("Erro ao fazer parse do JSON:", error.message);
    return ""
  }
}

export function getBannerObject(banner){
  try{
          const data =
                typeof jsonString === "string"
                  ? JSON.parse(banner)
                  : banner;
          const properties = data?.properties
          const url = properties?.MGAM_imagem[0]?.url
          const textoBanner = properties?.MGAM_textoBanner
          const link = properties?.link[0]

        return {url:url, textoBanner:textoBanner, link:link}
  }catch(error){
    console.error("Erro ao fazer parse do JSON:", error.message);
    return {};
  }
}
